import { Select } from "@mantine/core";
import { type MRT_ColumnDef } from "mantine-react-table-open";
import { type Todo, TodoStatus } from "../../../utils/backend-types";
import { TodosListColumnKeys } from "../TodoTable/TodoTable";

const statusLabelMapping = {
  [TodoStatus.Open]: "Offen",
  [TodoStatus.Done]: "Erledigt",
  [TodoStatus.NotRelevant]: "Nicht relevant"
};

const statusFilterData = Object.keys(statusLabelMapping).map((key) => ({
  value: key,
  label: statusLabelMapping[key]
}));

export function getStatusColumn(
  handleChangeStatus: (statusValue: TodoStatus, todoId: number) => void
): MRT_ColumnDef<Todo> {
  return {
    accessorKey: TodosListColumnKeys.Status,
    header: "Status",
    enableGrouping: false,
    Cell: ({ row }) => (
      <Select
        data={Object.keys(statusLabelMapping).map((key) => ({
          value: key,
          label: statusLabelMapping[key]
        }))}
        value={row.original.status}
        onChange={(value) =>
          handleChangeStatus(value as TodoStatus, row.original.id)
        }
      />
    ),
    filterVariant: "multi-select",
    filterTooltipValueFn: (value) => statusLabelMapping[value],
    mantineFilterMultiSelectProps: {
      data: statusFilterData,
      searchable: false,
      dropdownOpened: true
    }
  };
}
